// extracted by mini-css-extract-plugin
export default {"stats":"styles_stats__sKKYc"};